var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.93093 1.08418L18.3371 12.8965C18.6713 13.1376 18.875 13.5541 18.875 14.0001C18.875 14.4462 18.6713 14.8628 18.3371 15.1037L1.93093 26.9161C1.73867 27.0557 1.51664 27.125 1.29691 27.125C1.10465 27.125 0.910082 27.0712 0.736168 26.9648C0.358459 26.7341 0.125 26.2931 0.125 25.8125V2.18777C0.125 1.70716 0.358459 1.26616 0.736168 1.03545C1.10696 0.807327 1.57157 0.821477 1.93093 1.08418ZM15.5356 14.0001L2.46871 4.59233V23.4079L15.5356 14.0001Z","fill":"currentColor"}));
}

Play.defaultProps = {"width":"19","height":"28","viewBox":"0 0 19 28","fill":"none"};

module.exports = Play;

Play.default = Play;
